import React from "react";
import { TimelinePoint } from "./TimelinePoint";

interface HotelTimelineProps {
  bookingDate: string | Date;
  checkInDate: string | Date;
  checkOutDate: string | Date;
  checkinCompleted?: boolean;
  checkoutCompleted?: boolean;
}

export const HotelStayTimeline = ({
  bookingDate,
  checkInDate,
  checkOutDate,
  checkinCompleted,
  checkoutCompleted,
}: HotelTimelineProps) => {
  return (
    <div className="relative flex w-full justify-between">
      <div className="absolute top-[5px] right-0 left-0 z-0 h-[1px] bg-neutral-200" />
      <TimelinePoint
        label="Booked"
        date={bookingDate}
        isActive={!checkinCompleted}
        align="start"
      />
      <TimelinePoint
        label="Checked-In"
        date={checkInDate}
        isActive={checkinCompleted && !checkoutCompleted}
        align="center"
      />
      <TimelinePoint
        label="Checked-Out"
        date={checkOutDate}
        isActive={checkoutCompleted}
        align="end"
      />
    </div>
  );
};
